import { sendIQ } from './serverConnection'
import * as xmpp from '../../global/xmppPayloadHelper'
import { parseGroupFromSearchResults } from '../../global/messageParserHelper'
import chatLog from '../../global/chat-log'

/*
  https://xmpp.org/extensions/xep-0055.html#example-3
 */
export const searchForChatRoomFromChatServer = ({ connection, chatRoom }) => {
  chatLog(`[Search] Searching for chat room: ${chatRoom}`)
  const stanza = xmpp.payloadToSearchForChatRoom({ chatRoom })
  return sendIQ({ connection, stanza, parseFn: parseGroupFromSearchResults })
}

export const dummy = () => {}
